import classNames from 'classnames';
import React from 'react';
import Chart from 'react-apexcharts';
import { DEFAULT_CHART_COLORS } from '../../configs';
import Loader from '../base/Loader/Loader';

export const EMPTY_BAR_CHART_HEIGHT = 350;
export const MIN_BAR_CHART_HEIGHT = 320;
export const BAR_CHART_ROW_HEIGHT = 58;
export const BAR_CHART_BASE_HEIGHT = 150;
export const BAR_CHART_MAX_VISIBLE_HEIGHT = 760;
export const MAX_AXIS_LABEL_LENGTH = 34;

export const calculateBarChartHeight = (labelCount = 0) => {
  const count = Number(labelCount) || 0;
  if (count <= 0) {
    return EMPTY_BAR_CHART_HEIGHT;
  }

  return Math.max(MIN_BAR_CHART_HEIGHT, (count * BAR_CHART_ROW_HEIGHT) + BAR_CHART_BASE_HEIGHT);
};

export const getBarChartWrapperStyle = height => {
  if (height <= BAR_CHART_MAX_VISIBLE_HEIGHT) {
    return undefined;
  }

  return {
    maxHeight: BAR_CHART_MAX_VISIBLE_HEIGHT,
    overflowY: 'auto',
    overflowX: 'hidden',
  };
};

export const truncateAxisLabel = (value = '') => {
  const label = String(value ?? '');
  if (label.length <= MAX_AXIS_LABEL_LENGTH) {
    return label;
  }

  return `${label.slice(0, MAX_AXIS_LABEL_LENGTH - 1)}…`;
};

export default function ApexBarChart(props) {
  const {
    series = [],
    labels = [],
    barLabels = [],
    title = '',
    className = '',
    renderFooter = () => {
    },
    loading = false,
    colors = DEFAULT_CHART_COLORS,
    tooltipCustom = null,
    emptyText = 'Нет данных для отображения',
  } = props;
  const chartHeight = calculateBarChartHeight(labels.length);
  const wrapperStyle = getBarChartWrapperStyle(chartHeight);

  const options = {
    chart: {
      type: 'bar',
      height: chartHeight,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors,
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 2,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 1,
            style: {
              fontSize: '13px',
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['#fff'],
    },
    title: {
      text: title,
      style: {
        fontSize: '15px',
        fontWeight: 500,
        fontFamily: 'GOSTUI2, Helvetica Neue, Helvetica, Arial, sans-serif',
        color: '#1665A7',
      },
    },
    xaxis: {
      categories: labels,
      labels: {
        show: Boolean(labels.length),
      },
    },
    yaxis: {
      show: Boolean(labels.length),
      title: {
        text: undefined,
      },
      labels: {
        maxWidth: 220,
        formatter: truncateAxisLabel,
      },
    },
    tooltip: {
      custom: tooltipCustom || undefined,
      y: {
        // formatter: undefined,
        title: {
          formatter: (seriesName, opts) => [barLabels[opts.seriesIndex]],
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40,
      formatter(seriesName, opts) {
        return [barLabels[opts.seriesIndex]];
      },
      fontSize: '16px',
      fontFamily: "'GOSTUI2', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      labels: {
        color: undefined,
        useSeriesColors: true,
      },
    },
    dataLabels: {
      enabled: true,
      formatter(val, opts) {
        return val || '';
      },
    },
    noData: {
      text: emptyText,
      align: 'center',
      verticalAlign: 'middle',
    },
  };

  return (
    <div className={classNames('card-block-wrapper', className)}>
      <Loader loading={loading} />
      <div className="card-block chart-block">
        <div className="chart-block-content">
          <div className="chart-graph">
            {/* {yAxisTitle && <div className='axis-title y-axis-title'><div className='axis-title-text'>{yAxisTitle}</div></div>} */}
            {/* <div className={classNames('chart-wrapper', { 'yTitle': !!yAxisTitle }, { 'xTitle': !!xAxisTitle })}> */}
            <div className="apex-chart-wrapper apex-scroll" style={wrapperStyle}>
              <Chart options={options} series={series} type="bar" height={chartHeight} />
            </div>
            {/* {xAxisTitle && <div className='axis-title x-axis-title'>{xAxisTitle}</div>} */}
          </div>
        </div>
        {renderFooter()}
      </div>
    </div>
  );
}
